import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        boxSizing: 'border-box',
        padding: '1.5rem',
        color: '#333',
        textAlign: 'center'
    },
    title: {
        margin: 0,
        fontSize: '1.75rem',
        fontWeight: 500
    },
    subtitle: {
        margin: '0.75rem 0 0',
        maxWidth: '36rem',
        fontSize: '1rem',
        lineHeight: 1.5
    }
}));

const Maintenance = () => {
    const classes = useStyles();

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/maintenance">
                    <main className={classes.root}>
                        <h1 className={classes.title}>Maintenance.</h1>
                        <p className={classes.subtitle}>
                            Pour une raison sûrement très importante, il n'est pour l'instant pas possible d'administrer le site.
                        </p>
                    </main>
                </Route>
                <Redirect to="/maintenance" />
            </Switch>
        </BrowserRouter>
    );
};

export default Maintenance;
